import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(name, email, password);
      toast.success("Account created — complete your profile to go live!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not register");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-grain">
      <Card className="w-full max-w-md p-8 shadow-xl">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-heading font-bold">Become a tutor</h1>
          <p className="text-sm text-muted-foreground mt-1">Create your tutor profile in under a minute.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="r-name">Full name</Label>
            <Input
              id="r-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="r-email">Email</Label>
            <Input
              id="r-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="r-pw">Password</Label>
            <Input
              id="r-pw"
              type="password"
              required
              minLength={6}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full rounded-full h-11"
            data-testid="register-submit-button"
          >
            {submitting ? "Creating…" : "Create tutor account"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground text-center mt-5">
          Already have an account?{" "}
          <Link to="/login" className="text-primary font-medium link-underline">
            Sign in
          </Link>
        </p>
      </Card>
    </div>
  );
}
